// OnboardingDocumentUploadRequestedLoa
export const RequestedLoaEvent = {
  domain: "Onboarding",
  subdomain: "DocumentUpload",
  action: "RequestedLoa",
  page: "DocumentPurposeDetails",
}

// OnboardingDocumentUploadSelectedUploadMethod
export const SelectedUploadMethodEvent = {
  domain: "Onboarding",
  subdomain: "DocumentUpload",
  action: "SelectedUploadMethod",
  page: "DocumentPurposeDetails",
}

// OnboardingDocumentUploadSubmittedPhoto
export const SubmittedPhotoEvent = {
  domain: "Onboarding",
  subdomain: "DocumentUpload",
  action: "SubmittedPhoto",
}

// OnboardingDocumentUploadViewedPage
export const ViewedPageEvent = {
  domain: "Onboarding",
  subdomain: "DocumentUpload",
  action: "ViewedPage",
}

// OnboardingDocumentUploadViewedPurpose
export const ViewedPurposeEvent = {
  domain: "Onboarding",
  subdomain: "DocumentUpload",
  action: "ViewedPurpose",
  page: "DocumentPurposeDetails",
}

export const capitalize = (word: string) =>
  word && word.length > 1 ? word[0].toUpperCase() + word.substr(1).toLowerCase() : word

export const sanitizePage = (raw: string) =>
  raw
    .trim()
    // corresponding pattern in tracking-service
    // https://github.com/iZettle/tracking-service/blob/master/src/main/java/com/izettle/data/tracking/configuration/WhitelistEntry.java
    .replace(/[^0-9a-zA-Z]+/g, "")

const pathnameToPage = (path: string) => path.split("/").map(capitalize).join("")

export type TrackingMetadata = {
  domain: string
  subdomain: string
  action: string
  page?: string // Defaults to current path
  payload?: Record<string, unknown>
}

declare const window: any

export const sendToTrackingService = ({
  domain,
  subdomain,
  page,
  action,
  payload,
}: TrackingMetadata) => {
  const pageOrPathname = sanitizePage(page ?? pathnameToPage(window.location.pathname))
  window.izPushEvent(domain, subdomain, pageOrPathname, action, payload)
}
